module.exports = __webpack_public_path__ + "img/loons_01.4b0fdfdd.png";